export enum WizardViewMode {
    EnterMethodName = 0,
    Information = 1,
    ScanCode = 2,
    EnterCode = 3
}